import { render, staticRenderFns } from "./JcdcAlert.vue?vue&type=template&id=c284c394"
import script from "./JcdcAlert.vue?vue&type=script&lang=ts"
export * from "./JcdcAlert.vue?vue&type=script&lang=ts"
import style0 from "./JcdcAlert.vue?vue&type=style&index=0&id=c284c394&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports